<template>
<div>
</div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
  },
  data() {
    return {
      token: this.$route.query.token,
    }
  },
  mounted() {
    this.login()
  },
  methods: {
    login() {
      useJwt.setToken(this.token)
      useJwt.login()
        .then(response => {
          if (response.data.code !== 0) return this.$router.push({name: 'auth-login'})
          let userData = response.data.result.profile
          // useJwt.setToken(response.data.result.token)
          // useJwt.setRefreshToken(response.data.refreshToken)
          switch (userData.role) {
            case 'admin':
              userData.ability = [ { "action": "manage", "subject": "all" } ]
              break
            case 'system':
              userData.ability = [ { "action": "read", "subject": "page" }, { "action": "read", "subject": "credit" }, { "action": "read", "subject": "user" } ]
              break
            case 'employee':
              userData.ability = [ { "action": "read", "subject": "page" }, { "action": "read", "subject": "credit" } ]
              break
            default:
              userData.ability = [ { "action": "read", "subject": "Auth" } ]
          }
          localStorage.setItem('userData', JSON.stringify(userData))
          this.$ability.update(userData.ability)

          this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Welcome ${userData.displayName || userData.username}`,
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                },
              })
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
</style>
